import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { InputCustomEvent } from "@ionic/vue";
import { computed, ref, onMounted, onBeforeUnmount } from "vue";

import { INITIAL_TIMER, TIMER_MIN, TIMER_SUBSTRACTION } from "@/assets/variables";

// import { ION_VARIANT } from "@/types/enum/ionicEnum";
import { InputAmountPerformanceProps } from "@/types/props";
import { InputAmountEmits } from "@/types/emits";
// import { appResult } from "@/functions/enviroment";


export default /*@__PURE__*/_defineComponent({
  __name: 'InputAmountPerformanceNewWeb',
  props: {
    modelValue: {},
    amountStep: { default: 1 },
    min: { default: 0 },
    max: {},
    disabled: { type: Boolean },
    directInputDisabled: { type: Boolean },
    web: { type: Boolean }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const amountInput = ref()

let intervalId: ReturnType<typeof setTimeout>;
let changeTimer = INITIAL_TIMER;

let preventBlur = false

const inputValue = computed<number>({
    get: () => {
        if (props.modelValue === undefined) return 0
        return Number(props.modelValue)
    },
    set: async (value) => {
        // const convertedNumber = Number(value)
        const convertedNumber = Number(String(value).replace(/[^0-9]*/g, ''));

        if (isNaN(convertedNumber) || convertedNumber < props.min) {
            emit('update:modelValue', props.min)
            amountInput.value.value = props.min;
            return
        }

        if (props.max && convertedNumber > props.max) {
            emit('update:modelValue', props.max)
            amountInput.value.value = props.max;
            return
        }

        // if (amountInput.value?.value.length === 0) {
        //     amountInput.value.value = 0
        // }

        // // remove '0' at the beginnig: 025 -> 25
        // if (amountInput.value?.value.length <= 2 && +amountInput.value.value[0] === 0) {
        //     amountInput.value.value = convertedNumber;
        // }

        amountInput.value.value = convertedNumber;

        emit('update:modelValue', convertedNumber)
        emit('change', convertedNumber)
    },
})

const select = (event: InputCustomEvent): void => {
    if (event.target.select) { // tapped directly on html input
        preventBlur = true
        event.target.select();
    } else if (event.target.children[0].select) { // tapped on the wrapper
        preventBlur = true
        event.target.children[0].select();
    }
}

const removeInterval = () => {
    clearInterval(intervalId)
    changeTimer = INITIAL_TIMER
}

const setUpdateInterval = (modifier: 'plus' | 'minus') => {
    clearInterval(intervalId)
    changeTimer = changeTimer - TIMER_SUBSTRACTION >= TIMER_MIN ? changeTimer - TIMER_SUBSTRACTION : TIMER_MIN
    intervalId = setTimeout(() => {
        inputValue.value += modifier === 'plus' ? props.amountStep : (-1 * props.amountStep)
        setUpdateInterval(modifier)
    }, changeTimer)
}

const changeValue = (modifier: 'plus' | 'minus'): void => {
    if (modifier === 'minus' && inputValue.value === 0) return;
    inputValue.value += modifier === 'plus' ? props.amountStep : (-1 * props.amountStep)

    setUpdateInterval(modifier)
}

const handleKeydown = (e: KeyboardEvent) => {
    if (!isNaN(Number(e.key)) && Number(e.key) >= 0 && Number(e.key) <= 9 || e.key === 'Backspace') {
        // do default
    } else {
        e.preventDefault();
    }
}

onMounted(() => {
  document.addEventListener('mouseup', removeInterval)
})

onBeforeUnmount(() => {
  document.removeEventListener('mouseup', removeInterval)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"])),
    class: "root"
  }, [
    _createElementVNode("button", {
      type: "button",
      class: "minus",
      onMousedown: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (changeValue('minus')), ["stop"])),
      onMouseup: removeInterval,
      onContextmenu: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop","prevent"]))
    }, [...(_cache[8] || (_cache[8] = [
      _createElementVNode("svg", {
        width: "13px",
        fill: "currentColor",
        viewBox: "0 0 79 79",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        _createElementVNode("path", { d: "M 78.31 47.98 L 0.74 47.98 L 0.74 42.63 L 78.31 42.63 Z" })
      ], -1)
    ]))], 32),
    _createElementVNode("div", {
      class: _normalizeClass(["amount", { 'notNull': inputValue.value !== 0 }])
    }, [
      _withDirectives(_createElementVNode("input", {
        ref_key: "amountInput",
        ref: amountInput,
        type: "text",
        inputmode: "numeric",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inputValue).value = $event)),
        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (select($event)), ["stop"])),
        onKeydown: [
          handleKeydown,
          _cache[4] || (_cache[4] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"]))
        ]
      }, null, 544), [
        [_vModelText, inputValue.value]
      ])
    ], 2),
    _createElementVNode("button", {
      type: "button",
      class: "plus",
      onMousedown: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (changeValue('plus')), ["stop"])),
      onMouseup: removeInterval,
      onContextmenu: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop","prevent"]))
    }, [...(_cache[9] || (_cache[9] = [
      _createElementVNode("svg", {
        width: "13px",
        viewBox: "0 0 79 79",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        _createElementVNode("path", { d: "M 36.48 78.91 L 36.48 42.37 L 0.01 42.37 L 0.01 36.36 L 36.48 36.36 L 36.48 -0.04 L 42.34 -0.04 L 42.34 36.36 L 78.96 36.36 L 78.96 42.37 L 42.34 42.37 L 42.34 78.91 Z" })
      ], -1)
    ]))], 32)
  ]))
}
}

})